<div class='page--building-level-real-estate-transactions-page--market-data-overview-desktop--pie-chart-tooltip'>
	<div class='page--building-level-real-estate-transactions-page--market-data-overview-desktop--pie-chart-tooltip-header'><%= name %></div>
	<div class='page--building-level-real-estate-transactions-page--market-data-overview-desktop--pie-chart-tooltip-content'>
	    <div class='point' style='color:<%= color%>'>&#9679</div>
	    <%= y %>
    </div>
</div>
